import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  reserved: 'Reserved',
  under_lease: 'Under Lease',
  in_custody: 'In Custody',
  drop_off_scheduled: 'Drop Off Scheduled',
  pending_drop_off: 'Pending Drop Off',
  inspection_needed: 'Inspection Needed',
  maintenance_needed: 'Maintenance Needed',
  ready_for_use: 'Ready For Use',
  out_of_commission: 'Out Of Commission',
  not_available: 'Not Available',
  pending_hse_approval: 'Pending Hse Approval',
  pending_fleetio_inspection: 'Pending Fleetio Inspection',
};

@Pipe({
  name: 'lamStatus',
})
export class LamStatusPipe implements PipeTransform {
  public transform(value: string): unknown {
    return statuses[value];
  }
}
